import { render, staticRenderFns } from "./TheLessonView.vue?vue&type=template&id=0f218bc2&scoped=true&"
import script from "./TheLessonView.vue?vue&type=script&lang=js&"
export * from "./TheLessonView.vue?vue&type=script&lang=js&"
import style0 from "./TheLessonView.vue?vue&type=style&index=0&id=0f218bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f218bc2",
  null
  
)

export default component.exports